import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetInitiativesForSonarObjectRequest = {
	sonarObjectId: number;
};

export type GetInitiativesForSonarObjectResponse = {
	ids: Array<number>;
};

export const getInitiativesForSonarObject = createGetEndpoint<
	GetInitiativesForSonarObjectRequest,
	GetInitiativesForSonarObjectResponse
>(({ sonarObjectId }) => `/api/v3/initiatives/by-scope/${sonarObjectId}/`);
